import React, { useState, useEffect } from "react";
import {   Input,Divider,Alert,Steps } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";

import { systemFieldConfig, getValueFromPath } from "./systemFieldConfig";
import { Tooltip } from "antd";
import * as api from "../constants/api";
import { adalApiFetch } from "../adalConfig";
import { Tag, Space, Popover, Button, Table, Typography } from "antd";
import { CopyOutlined } from "@ant-design/icons";
const { Text } = Typography;
const SystemStatusesTable = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const fetchSystemStatuses = async (page, pageSize, searchTerm = "") => {
    setLoading(true);
    try {

      const response = await adalApiFetch(
        fetch,
        `${api.GET_SYSTEMSTATUS}?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm.trim()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      // const response = 
     
      // await axios.get( `${api.GET_SYSTEMSTATUS}?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm.trim()}`);
      const response1=await  response.json();
      let items = [];
      let total = 0;

      if (response1 && response1.data && response1.data.items) {
        items = Array.isArray(response1.data.items) ? response1.data.items : [];
        total = typeof response1.data.total === "number" ? response1.data.total : 0;
      }

      const formatted = items.map((item) => ({
        ...item,
        key: item.ngcReferenceId,
      }));

      setData(formatted);
      setTotalRecords(total);
    } catch (error) {
      console.error("Error fetching system statuses:", error);
      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSystemStatuses(page, pageSize);
  }, []);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    setExpandedRowKeys([]);
    fetchSystemStatuses(pagination.current, pagination.pageSize, searchTerm);
  };
  var PIPELINE = [
    { activity: "A_InvokeSFDC",                 system: "SFDC",            label: "SFDC" },
    { activity: "A_CheckSAPContactID",          system: "SAP ContactFul",  label: "SAP Contact FullFillment" },
    { activity: "A_InvokeCreateEMSCommercial",  system: "EMSCreate",       label: "EMS Create" },
    { activity: "A_InvokeUpdateNGCOrgCommercial", system: "NGCUpdateORG",  label: "NGC Update Org" },
    { activity: "A_InvokeAddEnablementCommercial", system: "NGCEnablement", label: "NGC Enablement" },
    { activity: "A_InvokeLGSAppHub",            system: "IDM",             label: "LGS Transfers" },
    { activity: "A_InvokeAppHUB",               system: "AppHUB",          label: "AppHub" }
  ];
  
  /* activity → system (for mapping error strings to the system) */
  var ACTIVITY_TO_SYSTEM = {};
  for (var i = 0; i < PIPELINE.length; i++) ACTIVITY_TO_SYSTEM[PIPELINE[i].activity] = PIPELINE[i].system;
  
  /* ------------ JSON helpers (no optional chaining) ------------ */
  function tryParseJson(x) {
    if (!x || typeof x !== "string") return x;
    var t = x.trim(), c = t.charAt(0);
    if (c !== "{" && c !== "[") return x;
    try { return JSON.parse(t); } catch (_e) { return x; }
  }
  function getPath(obj, path) {
    var cur = obj;
    for (var i = 0; i < path.length; i++) {
      if (cur === null || cur === undefined) return undefined;
      var key = path[i];
      if (typeof key === "number") {
        if (Object.prototype.toString.call(cur) !== "[object Array]") return undefined;
        if (key < 0 || key >= cur.length) return undefined;
        cur = cur[key];
      } else {
        if (!Object.prototype.hasOwnProperty.call(cur, key)) return undefined;
        cur = cur[key];
      }
    }
    return cur;
  }
  function normalizeStatus(s) {
    if (!s) return null;
    var up = String(s).trim().toUpperCase();
    if (up.indexOf("SUCC") >= 0) return "SUCCESS";
    if (up.indexOf("ERR")  >= 0) return "ERROR";
    if (up.indexOf("PEND") >= 0 || up.indexOf("WAIT") >= 0) return "PENDING";
    if (up === "2") return "SUCCESS";
    return up;
  }
  function parseErrorFromStatusOutputString(s) {
    if (!s || typeof s !== "string") return null;
    var activity = null, reason = null;
    var m1 = s.match(/activity function '([^']+)' failed:/i);
    if (m1 && m1[1]) activity = m1[1];
    var m2 = s.match(/failed:\s*"([^"]+)"/i);
    if (m2 && m2[1]) reason = m2[1];
    if (!reason) {
      var idx = s.toLowerCase().indexOf("failed:");
      if (idx >= 0) reason = s.substring(idx + 7).trim();
    }
    return (activity || reason) ? { activity: activity, reason: reason } : null;
  }
  
  /* ------------ value extractors per system (IDs to show on success) ------------ */
  /* We look under customStatus.APIResponse[System] common shapes you’ve shown. */
  function extractValueForSystem(rootApiResponse, systemName) {
    var node = (rootApiResponse && Object.prototype.hasOwnProperty.call(rootApiResponse, systemName))
      ? rootApiResponse[systemName] : null;
  
    if (!node) return null;
  
    // SFDC: ContactId (003...) if present, else show UserId (005...) or SCResponse.Message
    if (systemName === "SFDC") {
      var cid = getPath(node, ["APIResponse","SFDCContactAPI","id"]);
      if (cid) return "ContactId: " + cid;
      var uid = getPath(node, ["APIResponse","SCResponse","userId"]);
      if (uid) return "UserId: " + uid;
      var msg = getPath(node, ["APIResponse","SCResponse","Message"]);
      if (msg) return msg;
    }
  
    // SAP ContactFul: if any SAP contact id or raw APIResponse string
    if (systemName === "SAP ContactFul") {
      var sapId = getPath(node, ["APIResponse","sapContactId"]);
      if (sapId) return "SAP Contact Id: " + sapId;
      var raw = getPath(node, ["APIResponse"]);
      if (typeof raw === "string") return raw;
    }
  
    // EMSCreate: entitlementStatus[].eid or deliveryId
    if (systemName === "EMSCreate") {
      var entArr = getPath(node, ["APIResponse","entitlementStatus"]);
      if (entArr && Object.prototype.toString.call(entArr) === "[object Array]" && entArr.length > 0) {
        var eids = [];
        for (var i = 0; i < entArr.length; i++) {
          var e = entArr[i];
          var eid = e && e.eid;
          var del = e && e.deliveryId;
          if (eid) eids.push(eid);
          else if (del) eids.push(del);
        }
        if (eids.length) return "EID(s): " + eids.join(", ");
      }
    }
  
    // NGCUpdateORG: NGCUpdateOrgResponse (string/number)
    if (systemName === "NGCUpdateORG") {
      var resp = getPath(node, ["APIResponse","NGCUpdateOrgResponse"]);
      if (resp != null) return String(resp);
    }
  
    // NGCEnablement: show Status or any known id
    if (systemName === "NGCEnablement") {
      var st = node.Status != null ? node.Status : node.status;
      if (st) return "Status: " + st;
      var en = getPath(node, ["APIResponse","enablementId"]);
      if (en) return "EnablementId: " + en;
    }
  
    // IDM: frequently a user or txn id if available
    if (systemName === "IDM") {
      var idmUser = getPath(node, ["APIResponse","userId"]) || getPath(node, ["APIResponse","id"]);
      if (idmUser) return "UserId: " + idmUser;
    }
  
    // AppHUB: transactionId1 (you mentioned earlier)
    if (systemName === "AppHUB") {
      var txn = getPath(node, ["APIResponse","transactionId1"]);
      if (txn) return "Txn: " + txn;
    }
  
    // fallback: show Status if nothing else
    var s = node.Status != null ? node.Status : node.status;
    if (s) return "Status: " + s;
  
    return null;
  }
  function chooseBaseApi(root) {
    if (!root) return {};
    var out = getPath(root, ["output"]);
    if (out && typeof out === "object") return out;
  
    var cs = getPath(root, ["customStatus","APIResponse"]);
    if (cs && typeof cs === "object") return cs;
  
    var api = getPath(root, ["APIResponse"]);
    if (api && typeof api === "object") return api;
  
    return root;
  }
  /* ------------ core derivation: statuses, messages, failure index ------------ */
  function derivePipeline(record) {
    // 1) root JSON (prefer full object; else string with just error)
    var raw = record && (record.statusOutput != null ? record.statusOutput : record.StatusOutput);
    var root = typeof raw === "string" ? tryParseJson(raw) : raw;
  
    // 2) find APIResponse node that contains per-system objects
    var api = chooseBaseApi(root);
  
    // 3) build per-system status/message maps from JSON if available
    var statusBySystem = {};
    var messageBySystem = {};
  
    for (var i = 0; i < PIPELINE.length; i++) {
      var sys = PIPELINE[i].system;
      var node = api && Object.prototype.hasOwnProperty.call(api, sys) ? api[sys] : null;
  
      var st = "UNKNOWN", msg = null;
      if (typeof node === "string") {
        st = normalizeStatus(node) || "UNKNOWN";
      } else if (node && typeof node === "object") {
        var rawSt = (node.Status != null ? node.Status : node.status);
        st = normalizeStatus(rawSt) || "UNKNOWN";
  
        if (node.Message != null) msg = String(node.Message);
        else if (node.APIResponse != null) {
          if (typeof node.APIResponse === "string") msg = String(node.APIResponse);
          else if (typeof node.APIResponse === "object") {
            if (node.APIResponse.error != null) msg = String(node.APIResponse.error);
            else if (node.APIResponse.SCResponse && node.APIResponse.SCResponse.Message != null)
              msg = String(node.APIResponse.SCResponse.Message);
          }
        }
      }
      statusBySystem[sys] = st;
      if (msg) messageBySystem[sys] = msg;
    }
  
    // 4) fold in error from the failure string (maps activity → system)
    var errInfo = parseErrorFromStatusOutputString(typeof raw === "string" ? raw : (getPath(root, ["output"]) || ""));
    var failSystem = null, failReason = null;
    if (errInfo && errInfo.activity && ACTIVITY_TO_SYSTEM[errInfo.activity]) {
      failSystem = ACTIVITY_TO_SYSTEM[errInfo.activity];
      failReason = errInfo.reason || "Step failed";
      // Don’t override if JSON already says SUCCESS
      if (String(statusBySystem[failSystem] || "").toUpperCase() !== "SUCCESS") {
        statusBySystem[failSystem] = "ERROR";
      }
      if (!messageBySystem[failSystem]) messageBySystem[failSystem] = failReason;
    } else if (errInfo && errInfo.reason) {
      failReason = errInfo.reason;
    }
  
    // 5) compute failure index (first step with ERROR)
    var failIdx = -1;
    for (var k = 0; k < PIPELINE.length; k++) {
      var sname = PIPELINE[k].system;
      if (String(statusBySystem[sname] || "").toUpperCase() === "ERROR") { failIdx = k; break; }
    }
  
    return {
      api: api,
      statusBySystem: statusBySystem,
      messageBySystem: messageBySystem,
      failIdx: failIdx,
      failSystem: failSystem,
      failReason: failReason
    };
  }
  
  /* ------------ renderer for the expander ------------ */
   function ExpandedPipeline(props) {
    var record = props && props.record;
    var statuses = record && Array.isArray(record.statuses) ? record.statuses : [];

    // Build a map of systemName -> status object for quick lookup
    var statusMap = {};
    for (var i = 0; i < statuses.length; i++) {
      var s = statuses[i];
      if (s && s.systemName) {
        statusMap[s.systemName] = s;
      }
    }

    // Helper to extract detail value from apiResponse using systemFieldConfig
    function extractDetail(systemName, apiResponse) {
      if (!apiResponse || typeof apiResponse !== "object") return null;
      var fields = systemFieldConfig[systemName];
      if (!fields || !fields.length) return null;
      
      var details = [];
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        var value = getValueFromPath(apiResponse, f.path);
        if (value != null && value !== "") {
          details.push(f.title + ": " + value);
        }
      }
      return details.length > 0 ? details.join(", ") : null;
    }

    // Helper to extract error message from apiResponse
    function extractErrorMessage(apiResponse) {
      if (!apiResponse) return null;
      if (typeof apiResponse === "string") return apiResponse;
      if (typeof apiResponse.APIResponse === "string") return apiResponse.APIResponse;
      if (apiResponse.APIResponse && apiResponse.APIResponse.error) return apiResponse.APIResponse.error;
      if (apiResponse.Message) return apiResponse.Message;
      return null;
    }

    // Build Steps items from PIPELINE order
    var items = [];

    for (var i = 0; i < PIPELINE.length; i++) {
      var step = PIPELINE[i];
      var sys = step.system;
      var statusObj = statusMap[sys];
      
      var st = statusObj ? String(statusObj.status || "").toUpperCase() : "NOT RUN";
      var apiResponse = statusObj ? statusObj.apiResponse : null;
      
      var statusProp = "wait";  // AntD Steps status: "wait" | "process" | "finish" | "error"
      var desc = null;

      if (st === "SUCCESS") {
        statusProp = "finish";
        var val = extractDetail(sys, apiResponse);
        desc = val ? <Text type="secondary">{val}</Text> : <Text type="secondary">Success</Text>;
      } else if (st === "ERROR" || st === "FAILED") {
        statusProp = "error";
        var errMsg = extractErrorMessage(apiResponse) || "Step failed";
        var truncated = errMsg.length > 150 ? errMsg.slice(0, 150) + "..." : errMsg;
        desc = (
          <Tooltip title={errMsg}>
            <Text type="danger">{truncated}</Text>
          </Tooltip>
        );
      } else if (st === "PENDING" || st === "WAITING") {
        statusProp = "process";
        desc = <Text type="secondary">Pending</Text>;
      } else if (st === "NOT RUN") {
        statusProp = "wait";
        desc = <Text type="secondary">Not Run</Text>;
      } else {
        // Handle other statuses like "SAPID FULFILLED"
        if (st.indexOf("FULFILLED") >= 0 || st.indexOf("COMPLETE") >= 0) {
          statusProp = "finish";
          var val2 = extractDetail(sys, apiResponse);
          desc = val2 ? <Text type="secondary">{val2}</Text> : <Text type="secondary">{st}</Text>;
        } else {
          statusProp = "wait";
          desc = <Text type="secondary">{st || "Unknown"}</Text>;
        }
      }

      items.push({
        title: step.label,
        status: statusProp,
        description: desc,
        icon: (statusProp === "finish"
          ? <Tag color="green">OK</Tag>
          : statusProp === "error"
            ? <Tag color="red">ERR</Tag>
            : statusProp === "process"
              ? <Tag color="gold">WAIT</Tag>
              : <Tag>…</Tag>)
      });
    }

    return (
      <div style={{ padding: 12 }}>
        <Steps
          direction="vertical"
          size="small"
          items={items}
        />
      </div>
    );
  }
  var SYSTEMS = [
    "SFDC","EMS","IDM","AppHUB","SAP ContactFul","Marketo","SFDC Approval","SFDCEval",
    "LGS","EMSCreate","NGCUpdateORG","NGCEnablement","NGCCreateEval","NGCEnablementEval"
  ];
  function SystemBadges(props) {
    var record = props && props.record;
    var map = record && (record.systemStatuses || record.SystemStatuses);
    var msgs = record && (record.systemMessages || record.SystemMessages);
  
    // fallback map if backend didn't populate
    if (!map) {
      map = {};
      for (var i = 0; i < SYSTEMS.length; i++) map[SYSTEMS[i]] = "UNKNOWN";
    }
    if (!msgs) msgs = {};
  
    return (
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: "6px" }}>
        {SYSTEMS.map(function (sys) {
          var st = map[sys] || "UNKNOWN";
          var color = tagColorForStatus(st);
          var tip = msgs[sys] ? (sys + ": " + st + " — " + msgs[sys]) : (sys + ": " + st);
          return (
            <Tooltip title={tip} key={sys}>
              <Tag color={color} style={{ marginRight: 0 }}>
                <span style={{ fontWeight: 600 }}>{sys}</span>&nbsp;—&nbsp;{st}
              </Tag>
            </Tooltip>
          );
        })}
      </div>
    );
  }
  function tagColorForStatus(status) {
    var s = (status || "UNKNOWN").toUpperCase();
    if (s === "SUCCESS") return "green";
    if (s === "ERROR")   return "red";
    if (s === "PENDING") return "gold";
    return "default";
  }
// formatter
function fmt(dt) {
  if (!dt) return "-";
  var d = new Date(dt);
  return isNaN(d.getTime()) ? String(dt) : d.toLocaleString();
}

// popover table (no Tag; colored text instead)
const serialPopoverColumns = [
  {
    title: "Serial Number",
    dataIndex: "serialNumber",
    key: "serialNumber",
    render: function (v, r) {
      return (
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          <span style={{ color: r && r.isValid ? "green" : "red", fontFamily: "monospace" }}>{v}</span>
          <Tooltip title="Copy">
            <Button
              size="small"
              icon={<CopyOutlined />}
              onClick={function () { navigator.clipboard.writeText(v); }}
              style={{ marginLeft: 6 }}
            />
          </Tooltip>
        </span>
      );
    },
  },
  {
    title: "Valid",
    dataIndex: "isValid",
    key: "isValid",
    render: function (v) {
      return <span style={{ color: v ? "green" : "red" }}>{v ? "VALID" : "INVALID"}</span>;
    },
  },
  {
    title: "Transaction Id",
    dataIndex: "transactionId",
    key: "transactionId",
    render: function (v) { return <code>{v || "-"}</code>; },
  },
  { title: "Created", dataIndex: "createdDate", key: "createdDate", render: fmt },
];

 function SerialSummaryCell(props) {
  var record = props && props.record;
  var maxInline = (props && typeof props.maxInline === "number") ? props.maxInline : 5;

  // allow lowerCamel or Pascal from backend
  var list = record && Array.isArray(record.serialNumbers)
    ? record.serialNumbers
    : (record && Array.isArray(record.SerialNumbers) ? record.SerialNumbers : []);

  if (!list || !list.length) return "-";

  // normalize keys
  list = list.map(function (x) {
    return {
      serialNumber: x.serialNumber != null ? x.serialNumber : x.SerialNumber,
      isValid: x.isValid != null ? x.isValid : x.IsValid,
      transactionId: x.transactionId != null ? x.transactionId : x.TransactionId,
      createdDate: x.createdDate != null ? x.createdDate : x.CreatedDate,
    };
  });

  var shown = list.slice(0, maxInline);
  var rest = list.slice(maxInline);
  var validCount = list.reduce(function (acc, x) { return acc + (x && x.isValid ? 1 : 0); }, 0);

  var popoverContent = (
    <div style={{ maxWidth: 640 }}>
      <div style={{ marginBottom: 8 }}>
        <Text strong>{validCount}/{list.length} valid</Text>
      </div>
      <Table
        size="small"
        columns={serialPopoverColumns}
        dataSource={list}
        rowKey={function (r, i) {
          var ref = (record && (record.ngcReferenceId || record.NgcReferenceId)) || "ref";
          var tx = r.transactionId || r.TransactionId || "tx";
          var sn = r.serialNumber || r.SerialNumber || String(i);
          return ref + "-" + tx + "-" + sn;
        }}
        pagination={{ pageSize: 8 }}
      />
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: "6px",                // use gap if supported
        whiteSpace: "normal",      // allow wrapping inside table cell
      }}
    >
      {shown.map(function (sn, i) {
        return (
          <span
            key={"inl-" + i}
            style={{
              color: sn.isValid ? "#76b900" : "red",
              fontFamily: "monospace",
              marginBottom: 6,      // fallback spacing if gap isn't supported
            }}
          >
            {sn.serialNumber}
          </span>
        );
      })}

      {rest.length > 0 && (
        <Popover placement="bottomLeft" content={popoverContent} trigger="click">
          <Button type="link" size="small" style={{ paddingLeft: 0, marginBottom: 6 }}>
            {"+" + rest.length + " more · " + validCount + "/" + list.length + " valid"}
          </Button>
        </Popover>
      )}
    </div>
  );
}


/* -------- helpers (no optional chaining) -------- */
function tryParseJson(x) {
  if (!x || typeof x !== "string") return x;
  var t = x.trim();
  var f = t.charAt(0);
  if (f !== "{" && f !== "[") return x;
  try { return JSON.parse(t); } catch (_e) { return x; }
}

function pruneKeysDeep(value, keysToRemove) {
  if (value === null || value === undefined) return value;
  if (Object.prototype.toString.call(value) === "[object Array]") {
    var arr = value, outArr = new Array(arr.length);
    for (var i = 0; i < arr.length; i++) outArr[i] = pruneKeysDeep(arr[i], keysToRemove);
    return outArr;
  }
  if (typeof value === "object") {
    var outObj = {};
    for (var k in value) {
      if (!Object.prototype.hasOwnProperty.call(value, k)) continue;
      var skip = false;
      for (var j = 0; j < keysToRemove.length; j++) if (k === keysToRemove[j]) { skip = true; break; }
      if (!skip) outObj[k] = pruneKeysDeep(value[k], keysToRemove);
    }
    return outObj;
  }
  return value;
}

function stripTopLevelEntries(root) {
  if (!root || typeof root !== "object") return root;
  var out = {};
  for (var k in root) {
    if (!Object.prototype.hasOwnProperty.call(root, k)) continue;
    var val = root[k], skip = false;
    if (k === "IDM") {
      if (typeof val === "string") skip = String(val).toLowerCase() === "success";
      else if (val && typeof val === "object" && Object.prototype.hasOwnProperty.call(val, "Status"))
        skip = String(val.Status).toLowerCase() === "success";
    } else if (k === "Update Request Status") {
      if (typeof val === "string") skip = val === "2";
      else if (typeof val === "number") skip = val === 2;
    }
    if (!skip) out[k] = val;
  }
  return out;
}

// safe path getter: getPath(obj, ["a","b",0,"c"])
function getPath(obj, path) {
  var cur = obj;
  for (var i = 0; i < path.length; i++) {
    if (cur === null || cur === undefined) return undefined;
    var key = path[i];
    if (typeof key === "number") {
      if (Object.prototype.toString.call(cur) !== "[object Array]") return undefined;
      if (key < 0 || key >= cur.length) return undefined;
      cur = cur[key];
    } else {
      if (!Object.prototype.hasOwnProperty.call(cur, key)) return undefined;
      cur = cur[key];
    }
  }
  return cur;
}

/* ---------- constants & simple helpers ---------- */
var SYSTEMS = [
  "SFDC","EMS","IDM","AppHUB","SAP ContactFul","Marketo","SFDC Approval","SFDCEval",
  "LGS","EMSCreate","NGCUpdateORG","NGCEnablement","NGCCreateEval","NGCEnablementEval"
];

var ACTIVITY_TO_SYSTEM = {
  A_InvokeSFDC: "SFDC",
  A_InvokeUpdateEMS: "EMS",
  A_InvokeIDM: "IDM",
  A_InvokeMarketo: "Marketo",
  A_InvokeCreateEMS: "EMS",
  A_CheckSFDCApproval: "SFDC Approval",
  A_InvokeLGS: "LGS",
  A_InvokeSFDCEval: "SFDCEval",
  A_InvokeCreateEMSCommercial: "EMSCreate",
  A_InvokeUpdateNGCOrgCommercial: "NGCUpdateORG",
  A_InvokeAddEnablementCommercial: "NGCEnablement",
  A_InvokeLGSAppHub: "LGSAppHub",
  A_CheckSAPContact: "SAP ContactFul",
  A_CheckSAPContactID: "SAP ContactFul"
};

function tagColorForStatus(status) {
  var s = (status || "UNKNOWN").toUpperCase();
  if (s === "SUCCESS") return "green";
  if (s === "ERROR")   return "red";
  if (s === "PENDING") return "gold";
  return "default";
}

function tryParseJson(x) {
  if (!x || typeof x !== "string") return x;
  var t = x.trim(), c = t.charAt(0);
  if (c !== "{" && c !== "[") return x;
  try { return JSON.parse(t); } catch (_e) { return x; }
}

function getPath(obj, path) {
  var cur = obj;
  for (var i = 0; i < path.length; i++) {
    if (cur === null || cur === undefined) return undefined;
    var key = path[i];
    if (typeof key === "number") {
      if (Object.prototype.toString.call(cur) !== "[object Array]") return undefined;
      if (key < 0 || key >= cur.length) return undefined;
      cur = cur[key];
    } else {
      if (!Object.prototype.hasOwnProperty.call(cur, key)) return undefined;
      cur = cur[key];
    }
  }
  return cur;
}

function normalizeStatus(s) {
  if (!s) return null;
  var up = String(s).trim().toUpperCase();
  if (up.indexOf("SUCC") >= 0) return "SUCCESS";
  if (up.indexOf("ERR")  >= 0) return "ERROR";
  if (up.indexOf("PEND") >= 0 || up.indexOf("WAIT") >= 0) return "PENDING";
  if (up === "2") return "SUCCESS";
  return up;
}

// Parse: "activity function 'A_X' failed: "Reason""
function parseErrorFromStatusOutputString(s) {
  if (!s || typeof s !== "string") return null;
  var activity = null, reason = null;

  var m1 = s.match(/activity function '([^']+)' failed:/i);
  if (m1 && m1[1]) activity = m1[1];

  var m2 = s.match(/failed:\s*"([^"]+)"/i);
  if (m2 && m2[1]) reason = m2[1];

  if (!reason) {
    var idx = s.toLowerCase().indexOf("failed:");
    if (idx >= 0) reason = s.substring(idx + 7).trim();
  }

  return (activity || reason) ? { activity: activity, reason: reason } : null;
}

/* ---------- core: derive maps then pick successes + error ---------- */
function deriveSystemMaps(record) {
  // Prefer backend-provided maps if present
  var map = record && (record.systemStatuses || record.SystemStatuses);
  var msgs = record && (record.systemMessages || record.SystemMessages);

  if (!map) {
    map = {}; msgs = msgs || {};
    // Try to derive from full JSON if available
    var raw = record && (record.statusOutput != null ? record.statusOutput : record.StatusOutput);
    var root = typeof raw === "string" ? tryParseJson(raw) : raw;

    // If not an object, just fallback to string-based error mapping below
    var api = (root && (getPath(root, ["customStatus","APIResponse"]) || getPath(root, ["APIResponse"]) || root)) || {};

    for (var i = 0; i < SYSTEMS.length; i++) {
      var sys = SYSTEMS[i];
      var node = api && Object.prototype.hasOwnProperty.call(api, sys) ? api[sys] : undefined;

      if (typeof node === "string") {
        map[sys] = normalizeStatus(node) || "UNKNOWN";
      } else if (node && typeof node === "object") {
        var st = node.Status != null ? node.Status : node.status;
        map[sys] = normalizeStatus(st) || "UNKNOWN";

        var msg = null;
        if (node.Message != null) msg = String(node.Message);
        else if (node.APIResponse != null) {
          if (typeof node.APIResponse === "string") msg = String(node.APIResponse);
          else if (typeof node.APIResponse === "object") {
            if (node.APIResponse.error != null) msg = String(node.APIResponse.error);
            else if (node.APIResponse.SCResponse && node.APIResponse.SCResponse.Message != null)
              msg = String(node.APIResponse.SCResponse.Message);
          }
        }
        if (msg) msgs[sys] = msg;
      } else {
        map[sys] = "UNKNOWN";
      }
    }
  }

  // If still no ERROR identified, fall back to parsing the error string and map activity → system
  var statusOutputStr = record && (record.statusOutput || record.StatusOutput);
  var err = parseErrorFromStatusOutputString(statusOutputStr);
  var errorSystem = null, errorReason = null;

  if (err && err.activity) {
    var sysFromAct = ACTIVITY_TO_SYSTEM[err.activity];
    if (sysFromAct) {
      errorSystem = sysFromAct;
      errorReason = err.reason || "Step failed";
      // Don’t override SUCCESS; else mark ERROR
      if (!map[sysFromAct] || String(map[sysFromAct]).toUpperCase() !== "SUCCESS") {
        map[sysFromAct] = "ERROR";
      }
      if (!msgs) msgs = {};
      if (!msgs[sysFromAct]) msgs[sysFromAct] = errorReason;
    }
  } else if (err && err.reason) {
    errorReason = err.reason; // show generic error if no system
  }

  return { statuses: map, messages: msgs || {}, errorSystem: errorSystem, errorReason: errorReason };
}

/* ---------- the expander you can plug in ---------- */
 function ExpandedStatusSummary(props) {
  var record = props && props.record;
  var derived = deriveSystemMaps(record);

  // Success list (green tags)
  var successSystems = [];
  for (var i = 0; i < SYSTEMS.length; i++) {
    var sys = SYSTEMS[i];
    if (String(derived.statuses[sys] || "").toUpperCase() === "SUCCESS") successSystems.push(sys);
  }

  // Error (show one primary error — the mapped system or first found)
  var errorSys = derived.errorSystem;
  var errorMsg = derived.errorReason;
  if (!errorSys) {
    // find any system with ERROR if activity mapping wasn't available
    for (var j = 0; j < SYSTEMS.length; j++) {
      var sName = SYSTEMS[j];
      if (String(derived.statuses[sName] || "").toUpperCase() === "ERROR") {
        errorSys = sName;
        if (!errorMsg) errorMsg = derived.messages[sName] || "Step failed";
        break;
      }
    }
  }

  return (
    <div style={{ padding: 12 }}>
      <div style={{ marginBottom: 6 }}>
        <Text strong>Successful systems</Text>
        <div style={{ marginTop: 6, display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {successSystems.length
            ? successSystems.map(function (sys) {
                var tip = derived.messages[sys] ? (sys + " — " + derived.messages[sys]) : sys;
                return (
                  <Tooltip title={tip} key={sys}>
                    <Tag color={tagColorForStatus("SUCCESS")} style={{ marginRight: 0 }}>
                      {sys}
                    </Tag>
                  </Tooltip>
                );
              })
            : <span style={{ color: "#999" }}>No successes reported.</span>
          }
        </div>
      </div>

      <Divider style={{ margin: "10px 0" }} />

      {errorSys ? (
        <Alert
          type="error"
          showIcon
          message={<span><b>{errorSys}</b> failed</span>}
          description={derived.messages[errorSys] || errorMsg || "Unknown error"}
        />
      ) : (
        <span style={{ color: "#999" }}>No error detected.</span>
      )}
    </div>
  );
}
function stripOuterQuotes(s) {
  if (typeof s !== "string") return s;
  var t = s.trim();
  var n = t.length;
  if (n >= 2 && t.charAt(0) === '"' && t.charAt(n - 1) === '"') return t.substring(1, n - 1);
  return t;
}

/* -------- expanded content: shows highlights + filtered JSON -------- */
 function ExpandedStatusOutput(props) {
  var record = props && props.record;
  var outRaw = record ? (record.statusOutput != null ? record.statusOutput : record.StatusOutput) : null;
  var outObj = tryParseJson(outRaw);

  if (!outObj) return <Text type="secondary">No status available.</Text>;

  // 1) deep prune heavy nodes
  var filtered = pruneKeysDeep(outObj, ["lineItemInfo", "LineItemInfo"]);
  // 2) strip noisy top-level entries
  var data = stripTopLevelEntries(filtered);

  // ----- extract fields you want -----
  var sfdcContactId = getPath(data, ["SFDC", "APIResponse", "SFDCContactAPI", "id"]);
  var sfdcUserId    = getPath(data, ["SFDC", "APIResponse", "SCResponse", "userId"]);

  var entArr = getPath(data, ["EMSCreate", "APIResponse", "entitlementStatus"]);
  var eids = [];
  if (entArr && Object.prototype.toString.call(entArr) === "[object Array]") {
    for (var i = 0; i < entArr.length; i++) {
      var eid = entArr[i] && entArr[i].eid;
      if (eid != null) eids.push(String(eid));
    }
  }

  var ngcUpdateResp = getPath(data, ["NGCUpdateORG", "APIResponse", "NGCUpdateOrgResponse"]);
  var ngcEnablement = getPath(data, ["NGCEnablement", "Status"]);
  var appHubTxnRaw  = getPath(data, ["AppHUB", "APIResponse", "transactionId1"]);
  var appHubTxn     = stripOuterQuotes(appHubTxnRaw);

  // pretty JSON for copy
  var pretty;
  try { pretty = JSON.stringify(data, null, 2); } catch (_e) { pretty = String(data); }

  return (
    <div style={{ padding: 12 }}>
      {/* Highlights */}
      <div style={{ marginBottom: 8 }}>
        <Text strong>Highlights</Text>
        <div style={{ display: "grid", gridTemplateColumns: "max-content 1fr", gap: "4px 12px", marginTop: 6 }}>
          <Text type="secondary">SFDC Contact Id</Text>
          <code>{sfdcContactId || "-"}</code>

          <Text type="secondary">SFDC User Id</Text>
          <code>{sfdcUserId || "-"}</code>

          <Text type="secondary">EMSCreate EID(s)</Text>
          <code>{eids.length ? eids.join(", ") : "-"}</code>

          <Text type="secondary">NGC Update Org Response</Text>
          <code>{ngcUpdateResp != null ? String(ngcUpdateResp) : "-"}</code>

          <Text type="secondary">NGC Enablement Status</Text>
          <code>{ngcEnablement != null ? String(ngcEnablement) : "-"}</code>

          <Text type="secondary">AppHUB Transaction</Text>
          <code>{appHubTxn != null ? String(appHubTxn) : "-"}</code>
        </div>
      </div>

      <Divider style={{ margin: "8px 0" }} />

      {/* Filtered JSON */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
        <Text strong>Raw status output (filtered)</Text>
        <Tooltip title="Copy JSON">
          <Button size="small" icon={<CopyOutlined />} onClick={function(){ navigator.clipboard.writeText(pretty); }}>
            Copy
          </Button>
        </Tooltip>
      </div> */}
      {/* <pre style={{ margin: 0, maxHeight: 380, overflow: "auto" }}>{pretty}</pre> */}
    </div>
  );
}
  const customGreen = "#76b900";
  const columns = [
    {
      title: "NGC Reference ID",
      dataIndex: "ngcReferenceId",
      key: "ngcReferenceId",
    },
    {
      title: "Registration ID",
      dataIndex: "registrationId",
      key: "registrationId",
      // render: (value) => (
      //   <a href={`/detail/${value}`}  rel="noopener noreferrer">
      //     {value}
      //   </a>
      // ),
    },

    {
      title: "Org Name",
      dataIndex: "orgName",
      key: "orgName",
    },

    {
      title: "Email ID",
      dataIndex: "emailID",
      key: "emailId",
    },

    {
      title: "Subscription Type",
      dataIndex: "subscriptionType",
      key: "subscriptionType",
    },

    {
      title: "Serials",
      key: "serials",
      render: (_, record) => <SerialSummaryCell record={record} maxInline={5} />,
    },

    {
      title: "GTS Status",
      dataIndex: "gtsStatus",
      key: "gtsStatus",
    },


    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      render: (date) => new Date(date).toLocaleString(),
    },

   


  


   
    {
      title: "Entitlement",
      dataIndex: "pakId",
      key: "pakId",
    },
    {
      title: "License Type",
      dataIndex: "licenseTypeName",
      key: "licenseTypeName",
    },
    {
      title: "Product Family",
      dataIndex: "productFamilyName",
      key: "productFamilyName",
    },


    //  {
    //   title: "System Status",
    //   key: "systemStatus",
    //   render: function (_v, record) {
    //     return <SystemBadges record={record} />;
    //  },
   // },

    {
      title: "Overall Status",
      dataIndex: "overallStatus",
      key: "overallStatus",
      render: (status) => (
        <Tag color={status === "Success" ? "green" : "red"}>
          {status}
        </Tag>
      ),
    },
    // {
    //   title: "Last Updated",
    //   dataIndex: "updatedAt",
    //   key: "updatedAt",
    //   render: (date) => new Date(date).toLocaleString(),
    // },
  ];
  const expandedRowRender1 = (record) => {
    debugger;
    const systemColumns = [
      {
        title: "System Name",
        dataIndex: "systemName",
        key: "systemName",
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => {
          const statusLower = (status || "").toLowerCase();
          let color = "orange";
          if (statusLower === "success") color = "green";
          else if (statusLower === "failed") color = "red";
  
          return <Tag color={color}>{status}</Tag>;
        },
      },
      {
        title: "User ID",
        key: "userId",
        render: (row) =>
          (row.apiResponse &&
            row.apiResponse.APIResponse.SCResponse &&
            row.apiResponse.APIResponse.SCResponse.userId) ||
          "-",
      },
      {
        title: "Status Code",
        key: "statusCode",
        render: (row) =>
          (row.apiResponse &&
            row.apiResponse.SCResponse &&
            row.apiResponse.SCResponse.StatusCode) ||
          "-",
      },
      {
        title: "Message",
        key: "message",
        render: (row) =>
          (row.apiResponse &&
            row.apiResponse.SCResponse &&
            row.apiResponse.SCResponse.Message) ||
          "-",
      },
    ];
  
    // ✅ Filter out "Not Run" (case-insensitive)
    const filteredStatuses = (record.statuses || []).filter(function (s) {
      return (s.status || "").toLowerCase() !== "not run";
    });
  
    // ✅ Sort: "Success" on top
    const sortedStatuses = filteredStatuses.sort(function (a, b) {
      const aStatus = (a.status || "").toLowerCase();
      const bStatus = (b.status || "").toLowerCase();
  
      if (aStatus === "success" && bStatus !== "success") return -1;
      if (aStatus !== "success" && bStatus === "success") return 1;
      return 0;
    });
  
    return (
      <Table
        columns={systemColumns}
        dataSource={sortedStatuses.map(function (status, index) {
          return {
            ...status,
            key: record.registrationId + "-" + index,
          };
        })}
        pagination={false}
        rowKey="key"
      />
    );
  };
  
  const expandedRowRender2 = (record) => {
    const columns = [
      {
        title: "System Name",
        dataIndex: "systemName",
        key: "systemName",
        render: (systemName) => {
          return (systemName || "").toUpperCase() === "IDM" ? "NLP" : systemName;
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (status) => {
          const statusLower = (status || "").toLowerCase();
          let color = "orange";
          if (statusLower === "success") color = "green";
          else if (statusLower === "failed") color = "red";
          return <Tag color={color}>{status}</Tag>;
        },
      },
      {
        title: "Details",
        key: "details",
        render: (row) => {
          const systemName = row.systemName;
    
          const api = row.apiResponse;
          const isRawString = typeof api === "string";

    // If it's a raw error string or fallback from backend
    if (isRawString) {
      const raw = api.trim();
      const truncated = raw.length > 200 ? raw.slice(0, 200) + "..." : raw;

      return (
        <Tooltip title={raw}>
          <Tag color="orange">
            <strong>Unparsed Response:</strong> {truncated}
          </Tag>
        </Tooltip>
      );
    }
          const fields = typeof api === "object" ? systemFieldConfig[systemName] || [] : [];
      
          const fieldElements = fields.map((f, i) => {
            const value = getValueFromPath(api, f.path) || "-";
            let aa=0;
            return (
              <div key={i}>
                <strong>{f.title}:</strong> {value}
              </div>
            );
          });
      
          const isError = (row.status || "").toLowerCase() === "error" || (row.status || "").toLowerCase() === "failed";
          const errorMessage = (typeof api.APIResponse === "string" && isError) ? api.APIResponse : null;
      
          let truncatedError = "";
          if (errorMessage) {
            truncatedError = errorMessage.length > 200 ? errorMessage.slice(0, 200) + "..." : errorMessage;
          }
      
          return (
            <div>
              {fieldElements}
              {errorMessage && (
                <div style={{ marginTop: 4 }}>
                  <Tooltip title={errorMessage}>
                    <Tag color="red">
                      <strong>Error:</strong> {truncatedError}
                    </Tag>
                  </Tooltip>
                </div>
              )}
            </div>
          );
        },
      }
      
    ];
  
    const filteredStatuses = (record.statuses || []).filter(function (s) {
      return (s.status || "").toLowerCase() !== "not run";
    });
  
    const sortedStatuses = filteredStatuses.sort(function (a, b) {
      const aStatus = (a.status || "").toLowerCase();
      const bStatus = (b.status || "").toLowerCase();
      if (aStatus === "success" && bStatus !== "success") return -1;
      if (aStatus !== "success" && bStatus === "success") return 1;
      return 0;
    });
  
    return (
      <Table
        columns={columns}
        dataSource={sortedStatuses.map((status, index) => ({
          ...status,
          key: `${record.registrationId}-${index}`,
        }))}
        pagination={false}
        rowKey="key"
      />
    );
  };
  
  

  return (
    <div style={{ padding: 20 }}>
     
      <div style={{ marginBottom: 16,marginLeft: 46 }}>
   
      <Input.Search
  placeholder="Search by Registration ID, Email, Pak ID..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  onSearch={() => fetchSystemStatuses(page, pageSize, searchTerm)}
  enterButton={
    <Button
      style={{
        backgroundColor: customGreen,
        borderColor: customGreen,
        color: "#fff",
      }}
      icon={<SearchOutlined />}
      size="large"
    >
      Search
    </Button>
    
  }
  allowClear
  size="large"
  style={{
    maxWidth: 500,
    marginBottom: 16,
    borderColor: customGreen,
    boxShadow: "0 0 0 2px transparent",
  }}
  onFocus={(e) => (e.target.style.boxShadow = `0 0 0 2px ${customGreen}50`)}
  onBlur={(e) => (e.target.style.boxShadow = "none")}
/>
<Button onClick={() => fetchSystemStatuses(page, pageSize)} style={{
        backgroundColor: customGreen,
        borderColor: customGreen,
        color: "#fff",
        marginLeft:20
      }}
   
      size="large"
    > 
     Refresh kratos Data
   </Button>

</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="key"
        loading={loading}
        expandable={{
          expandedRowRender: function (record) {
            return <ExpandedPipeline   record={record} />;
          },
          // optional tweaks:
          expandRowByClick: true,     // click row to expand
          columnWidth: 48,            // width of the expand icon column
        }}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: totalRecords,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default SystemStatusesTable;
